<div class="widget-row">
    <ng-container *ngFor="let widget of customerWidgets$ | async">
        <div *ngIf="widget.typeAction === 'policySelector'">
            <app-policy-selector-widget [widgetContent]="widget"></app-policy-selector-widget>
        </div>
        <div *ngIf="widget.typeAction === 'redirect'">
            <app-redirect-widget [widgetContent]="widget"></app-redirect-widget>
        </div> 
        <div *ngIf="widget.typeAction === 'modal'">
            <app-model-open-widget [widgetContent]="widget"></app-model-open-widget>
        </div>          
    </ng-container>
    
    <mapfre-modal [modalOptions]="customizeWidgetsModalOptions" [hideModal]="hideModal"
        (hideModalOutput)="hideModalAction($event)" (click)="onModalClick()">
        <div class="modal-body customize-widget-modal modal-border" cdkScrollable>
            <div class="title">
                {{ 'Customize your homepage' | translate }}
            </div> 
            
            <div class="sub-title">
                {{ 'Drag and drop your top 4 actions.' | translate }}
            </div>

            <div class="w-100-percent top-space" cdkDropListGroup>
                <div class="widget-customize-row mb-3">
                    <ng-container *ngFor="let widget of customizedWidgets; let indx = index">
                        <div
                            class="drag-highlight"
                            cdkDropList
                            [id]="'customizedWidget' + indx"
                            [cdkDropListData]="widget"
                            [cdkDropListSortingDisabled]="true"
                            [ngClass]="{ 'widget-tile drop-placeholder' : !widget || widget.id === draggedWidgetId }"
                            (cdkDropListDropped)="onDrop($event)"
                        >
                            <div *ngIf="widget" 
                                cdkDrag 
                                (cdkDragStarted)="onDragStarted(widget)"
                                (cdkDragEnded)="onDragEnded()"
                            >
                                <div *cdkDragPlaceholder></div>
                                <ng-template cdkDragPreview matchSize>
                                    <div class="widget-tile modal-widget-tile customized-widget-background drag-shadow">
                                        <div class="widget-icon-box cursor-move">
                                            <img src={{widget.icon}} alt="{{ widget.label | translate }} icon"/>
                                        </div>
                                        <div class="label-badge-row">
                                        <div class="widget-label">{{ widget.label | translate }}</div> 
                                            <div class="badge">{{ indx + 1 }}</div> 
                                        </div>
                                    </div>
                                </ng-template>
                                <div class="widget-tile modal-widget-tile customized-widget-background">
                                    <div class="widget-icon-box cursor-move">
                                        <img src={{widget.icon}} alt="{{ widget.label | translate }} icon"/>
                                    </div>
                                    <div class="label-badge-row">
                                        <div class="widget-label">{{ widget.label | translate }}</div> 
                                        <div class="badge">{{ indx + 1 }}</div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div
                    cdkDropList
                    id="widgets"
                    class="widget-customize-row"
                    [cdkDropListData]="actionWidgets"
                    [cdkDropListSortingDisabled]="true"
                    (cdkDropListDropped)="onDrop($event)"
                >
                    <div 
                        *ngFor="let widget of actionWidgets; let idx = index" 
                        cdkDrag
                        [cdkDragData]="widget"
                    >
                        <div *cdkDragPlaceholder></div>
                        <ng-template cdkDragPreview matchSize>
                            <div class="widget-tile modal-widget-tile drag-shadow">
                                <div class="widget-icon-box cursor-move">
                                    <img src={{widget.icon}} alt="{{ widget.label | translate }} icon"/>
                                </div>
                                <div class="widget-label">{{ widget.label | translate }}</div> 
                            </div>
                        </ng-template>
                        <div class="widget-tile modal-widget-tile">
                            <div class="widget-icon-box cursor-move">
                                <img src={{widget.icon}} alt="{{ widget.label | translate }} icon"/>
                            </div>
                            <div class="widget-label">{{ widget.label | translate }}</div> 
                        </div>
                    </div>
                </div>
            </div>

            <div class="btn-save-cancel top-space">
                <div class="">
                    <mapfre-button additionalClasses="ghost secondary large-btn" (click)="hideModalAction($event)">
                        {{ 'CANCEL' | translate }}
                    </mapfre-button>
                </div>
                <div>
                    <mapfre-button additionalClasses="basic primary large-btn" (click)="saveCustomWidget(); hideModalAction($event);">
                        {{ 'SAVA_CHANGES' | translate }}
                    </mapfre-button>
                </div>                    
            </div>
        </div>
    </mapfre-modal>
</div>
